IN.App.CellverificationController = Ember.Controller.extend({
	callswitch: 'CALL',
	tooltiperror: "De verificatiecode is niet correct, probeer opnieuw.",
	tooltiptitle: "1/3 pogingen",
	tooltipmessage: "Je hebt maximaal 3 pogingen",
	counter: 10,
	attempts: 0,
	callcode: null,
	callnumber1: null,
	callnumber2: null,
	callnumber3: null,
	showText: 'Bel me nu',
	needs: ["application", "inputemail", "login"],
	actions: {
		call: function (choice) {
			var self = this;
			var appContr = this.get('controllers.application');
			var loginContr = this.get('controllers.login');
			this.set('callswitch', choice);
			if(this.get('callswitch') === 'PENDING'){
				var data = {
					"email": loginContr.get('email'),
					"password": loginContr.get('password')
				}
				$.post("/v1/auth/login/send_token", JSON.stringify(data), function(response) {
					self.set('callnumber1', null);
					self.set('callnumber2', null);
					self.set('callnumber3', null);
					self.set('error', false);
					if(response.status == 'success'){
						var timer = setInterval(function(){
							if(self.attempts < 3){
								if(self.get('counter') > 0){
									self.set('counter', self.counter - 1);
								} else if(self.get('counter') === 0){
									clearInterval(timer);
									self.set('counter', 10);
									self.set('attempts', self.attempts + 1);
									self.set('tooltiptitle', self.attempts+"/3 pogingen");
									self.set('callswitch', 'CALLED');
									self.set('showText', 'Opnieuw bellen');
								}
							} else {
								clearInterval(timer);
								self.set('callswitch', 'CALLED');
								appContr.set('cell', false);
								self.set('tooltipmessage', "Je hebt alle pogingen verbruikt, probeer later nog eens.");
							}
						}, 1000);
					}
					if(response.status == 'error'){
						self.set('error', true);
					}
				}, "json");
			}
		},
		sendverification: function(){
			var loginContr = this.get('controllers.login');
			var self = this;
			var data = {
				"email": loginContr.get('email'),
				"password": loginContr.get('password'),
				"auth_token": this.callcode,
				"auth_method": "sms"
			};

			$.post("/v1/auth/confirm_login", JSON.stringify(data), function(response) {
				if(response.status == 'success'){
					window.location.href = window.location.search ? '/#/' + window.location.search : '/#/';
				}
				if(response.status == 'error'){
					self.set('error', true);
				}

			}, "json");
		}
	},
	callcodeObserver: function () {
	    var self = this;
	    this.set('callcode', this.callnumber1 + this.callnumber2 + this.callnumber3);
  	}.observes('callnumber1', 'callnumber2', 'callnumber3'),
	isCALL: function () {
		return this.get('callswitch') === 'CALL';
	}.property('callswitch'),
	isPENDING: function () {
		return this.get('callswitch') === 'PENDING';
	}.property('callswitch'),
	isCALLED: function () {
		return this.get('callswitch') === 'CALLED';
	}.property('callswitch')
});
